module.exports = __webpack_public_path__ + "static/media/doc-patient-stethoscope.1da755bb.jpg";